import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Modal from '../../../UniformComponents/Modal'
import Typography from '../../../UniformComponents/Typography'
import Button from '../../../UniformComponents/Button'

const DownloadWarningModal = ({ store }) => {
    const missing = store.slidesMissingQuestions

    return (
        <Modal
            show={store.downloadWarningOpen}
            onClose={store.closeDownloadWarning}
        >
            <Typography type="h2">{i18n.t('powerpoint.downloadWarning.title')}</Typography>

            <br />

            <hr />

            <br />

            <Typography type="p">
                {i18n.t('powerpoint.downloadWarning.description', { count: missing.length })}
            </Typography>

            <br />

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, padding: '16px 20px', border: '1px solid #CADAE1', borderRadius: 8, backgroundColor: '#F7F9FB', maxWidth: 360, margin: '0 auto' }}>
                {missing.map(({ sectionTitle, sectionIndex, slideIndex }) => (
                    <Typography key={`${sectionIndex}-${slideIndex}`} type="tiny-b">
                        {i18n.t('powerpoint.downloadWarning.slide', {
                            section: sectionTitle || `Section ${sectionIndex + 1}`,
                            number: slideIndex + 1,
                        })}
                    </Typography>
                ))}
            </div>

            <br />

            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10 }}>
                <Button
                    label={i18n.t('cancel')}
                    onClick={store.closeDownloadWarning}
                    cssClass="regular tertiary"
                />
                <Button
                    icon="far fa-download"
                    label={i18n.t('powerpoint.downloadWarning.submit')}
                    onClick={store.removeEmptySlidesAndDownload}
                    cssClass="regular primary"
                />
            </div>
        </Modal>
    )
}

export default observer(DownloadWarningModal)
